import { useQuery, UseQueryResult } from "react-query";
import { getAttendanceSummary } from "../../api/attendance";
import useCurrentResourceCentre from "../useCurrentResourceCentre";
import { IAttendanceSummaryRow } from "../../interfaces/AttendanceInterface";

interface UseAttendanceSummaryProps {
  employeeIds?: number[];
  serviceProviderIds?: number[];
  fromDate: string;
  toDate: string;
  enabled?: boolean;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useAttendanceSummary = ({
  employeeIds,
  serviceProviderIds,
  fromDate,
  toDate,
  enabled = true
}: UseAttendanceSummaryProps): UseQueryResult<IAttendanceSummaryRow[] | undefined, unknown> => {
  const rc = useCurrentResourceCentre();

  return useQuery({
    queryKey: ["attendance-summary", rc?.id, employeeIds, serviceProviderIds, fromDate, toDate],
    queryFn: async () => {
      const response = await getAttendanceSummary({
        resourceCentreId: Number(rc?.id),
        employeeIds,
        serviceProviderIds,
        fromDate,
        toDate
      });
      return response.data;
    },
    enabled: !!rc?.id && !!fromDate && !!toDate && enabled
  });
};

export default useAttendanceSummary;
